/**
 * 商品企画マスタ画面　予算・計画数一覧検索条件VOクラス
 */
export class KYMW1300GetPlanNumListModel {

  public dispMode: string = null;                                               // 表示モード(1：部門、2：ページ、3：バイヤー)
  public orderCode: string = null;                                              // 受注コード
  public mediumType: string = null;                                             // 媒体区分
  public sellAreaCode: string = null;                                           // 売り場コード
  public orderNumQuotaCode: string = null;                                      // 注文コード割当コード
  public coopCode: string = null;                                               // 生協コード
  public classCode: string = null;                                              // 部門コード
  public middleClassCode: string = null;                                        // 中分類コード
  public smallClassCode: string = null;                                         // 小分類コード
  public page: string = null;                                                   // ページ番号
  public buyerCode: string = null;                                              // バイヤーコード
  public orderClientCode: string = null;                                        // 発注先コード
  public orderClientKanji: string = null;                                       // 発注先名称
  public payeeClientCode: string = null;                                        // 支払先コード
  public payeeClientKanji: string = null;                                       // 支払先名称

  // フォーカスフラグ(0：表示ボタン、1：前へボタン、2：次へボタン、3：表示モード・部門、4：次回案内一括設定、5：次回案内チェック)
  public focusFlg: string = null;

}
